import React from 'react';

import { BaseIconProps } from '.';

export const GraphUptrendCircle = ({ fill }: BaseIconProps) => {
  return (
    <g transform="matrix(18.002261,0,0,17.967982,-15085.894,-7384.8405)">
      <g transform="translate(286,-182)">
        <path
          d="m 20748.832,13075 10.826,-9.949 5.391,3.4 9.328,-10.853"
          transform="translate(-20185.922,-12436.88)"
          fill="none"
          stroke={fill}
          strokeWidth="1.5"
        />
        <path
          d="M 0,0.9 9.09,0 9.284,8.65"
          transform="rotate(-3,12146.038,-10751.486)"
          fill="none"
          stroke={fill}
          strokeWidth="1.5"
        />
        <g
          transform="translate(557,599)"
          fill="none"
          stroke={fill}
          strokeWidth="1.5"
        >
          <circle cx="24.5" cy="24.5" r="24.5" stroke="none" />
          <circle cx="24.5" cy="24.5" r="23.75" fill="none" />
        </g>
        <g
          transform="translate(561,603)"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeWidth="1.5"
          strokeDasharray="0, 5"
        >
          <circle cx="20.5" cy="20.5" r="20.5" stroke="none" />
          <circle cx="20.5" cy="20.5" r="19.75" fill="none" />
        </g>
      </g>
      <rect
        width="60"
        height="60"
        transform="translate(838,411)"
        fill="none"
        x="0"
        y="0"
      />
    </g>
  );
};
